import { render, staticRenderFns } from "./fccEmuladores.vue?vue&type=template&id=68b363f8"
import script from "./fccEmuladores.vue?vue&type=script&lang=js"
export * from "./fccEmuladores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports